import React from "react";
import { AlertTriangle } from "lucide-react";

export function describeLoadError(e, what = "data") {
  const status = e?.response?.status;
  const detail = e?.response?.data?.detail;
  const text = typeof detail === "string" ? detail : Array.isArray(detail) ? detail.map((d) => d.msg || JSON.stringify(d)).join(" ") : "";
  let message;
  if (status === 401) message = `Your admin session isn't being recognised (401). Sign in again — if this keeps happening, make sure you're on https://accommodationsuppliers.com (not www).`;
  else if (status === 403) message = `This account doesn't have admin access (403).`;
  else if (status) message = text || `Failed to load ${what} (HTTP ${status}).`;
  else message = `Failed to load ${what} — network error or the server didn't respond.`;
  return { status, message };
}

export default function LoadErrorBanner({ error, onRetry, testId = "admin-load-error" }) {
  if (!error) return null;
  return (
    <div className="mb-4 border border-[#B35C4A] bg-[#FBECE8] text-[#B35C4A] px-4 py-3 text-sm flex flex-wrap items-center gap-3" role="alert" data-testid={testId}>
      <AlertTriangle className="w-4 h-4 shrink-0" />
      <span className="flex-1">{error.message}</span>
      {onRetry && <button type="button" onClick={onRetry} className="text-[10px] uppercase tracking-widest font-semibold border border-[#B35C4A] px-2 py-1 hover:bg-[#B35C4A] hover:text-white transition" data-testid={`${testId}-retry`}>Retry</button>}
      {error.status === 401 && <a href="/login" className="text-[10px] uppercase tracking-widest font-semibold bg-[#B35C4A] text-white px-2 py-1" data-testid={`${testId}-signin`}>Sign in again</a>}
    </div>
  );
}
